export default __webpack_public_path__ + "static/media/ipad.c3933e5c.jpg";